import { render, staticRenderFns } from "./gettingStarted.vue?vue&type=template&id=2ce1d0ca&"
import script from "./gettingStarted.vue?vue&type=script&lang=js&"
export * from "./gettingStarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports